(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.swipeReady) return;
      gallery.dataset.swipeReady = 'true';
      const stage = gallery.querySelector('.gallery-stage');
      let start = null;
      stage.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('video,iframe,button,a')) { start = null; return; }
        start = {x:event.touches[0].clientX,y:event.touches[0].clientY};
      }, {passive:true});
      stage.addEventListener('touchcancel', () => { start = null; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        const buttons = [...gallery.querySelectorAll('[data-gallery-target]')];
        const active = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        buttons[(active + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length]?.click();
      }, {passive:true});
      gallery.addEventListener('click', event => {
        if (!event.target.closest('[data-gallery-target]') || reduced.matches) return;
        const active = gallery.querySelector('.gallery-slide:not([hidden])');
        active?.classList.remove('is-changing');
        requestAnimationFrame(() => active?.classList.add('is-changing'));
      });
    });
    scope.querySelectorAll('.cart-line input[name="updates[]"]').forEach(input => {
      if (input.closest('.cart-quantity-control')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cart-quantity-control';
      input.before(wrapper);
      wrapper.append(input);
      [-1,1].forEach(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = direction < 0 ? '−' : '+';
        button.setAttribute('aria-label', input.dataset[direction < 0 ? 'decrease' : 'increase']);
        button.addEventListener('click', () => {
          direction < 0 ? input.stepDown() : input.stepUp();
          input.dispatchEvent(new Event('change', {bubbles:true}));
        });
        direction < 0 ? wrapper.prepend(button) : wrapper.append(button);
      });
    });
    scope.querySelectorAll('.mobile-nav').forEach(menu => {
      if (menu.dataset.enhanced) return;
      menu.dataset.enhanced = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
    });
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('motion-enter');
          observer.unobserve(entry.target);
        });
      }, {threshold:.12});
      scope.querySelectorAll('.section-head,.story-copy,.memory-benefits,.memory-stories,.how-visual,.memory-finale').forEach(element => {
        if (element.dataset.motionReady) return;
        element.dataset.motionReady = 'true';
        if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
      });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.mobile-nav[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
